export const FollowUpChannelEnum = Object.freeze({
  Email: 1,
  WhatsApp: 2
});
